/* eslint-disable no-param-reassign */
import numeral from 'numeral';

numeral.register('locale', 'es-CL', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },
  ordinal(number) {
    return number === 1 ? 'er' : 'eros';
  },
  currency: {
    symbol: '$',
  },
});
numeral.locale('es-CL');

export default ({ Vue }) => {
  Vue.prototype.$numeral = numeral;
};



// WEBPACK FOOTER //
// ./src/plugins/numeral-js.js